<script lang="ts">
  import { recommendation } from "../../../../stores/recommendation"
  import { ENV } from "../../../../util/env"

  import Text from "../../components/Text.svelte"
  import Title2 from "../../components/Title2.svelte"

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: details = $recommendation.details

  // $: baseUrl = `https://dev-media.gethumankind.com/${details.brand.id}/assets/css`
  $: baseUrl = details
    ? `${ENV.MEDIA_SERVICE_URL}/${details.brand.id}/assets/images`
    : undefined
</script>

<section>
  <img
    src="{baseUrl}/Full Mouth Dental Implants.png"
    alt="Full Mouth Dental Implants"
  />
  <div>
    <Title2 class="intro-title">Full Mouth Dental Implants</Title2>
    <Text center
      >Enjoy your favorite foods again with a permanent, new smile. Fixed full
      arch dental implants, also known as full mouth dental implants, restore
      90% chewing capacity so you can bite and chew with confidence.</Text
    >
  </div>
</section>

<style lang="scss">
  section {
    margin-bottom: 20px;
  }

  img {
    width: 100vw;
    height: 100vw;
    vertical-align: middle;
  }

  div {
    background-color: #e7e7e7;
    padding: 36px 20px;
  }

  :global(.intro-title) {
    margin-bottom: 8px !important;
  }

  @media (min-width: 768px) {
    section {
      display: flex;
      flex-direction: row-reverse;
      margin-bottom: 40px;
    }

    img,
    div {
      width: 50vw;
      height: 50vw;
      flex-grow: 1;
      box-sizing: border-box;
      max-height: 580px;
      object-fit: cover;
    }

    div {
      padding: 0 7%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    :global(.intro-title) {
      margin-bottom: 16px !important;
    }
  }
</style>
